import { ListLoadingDecorator, useListContext } from 'framework/list';
import { ShowContextProvider, ShowData } from 'framework/show';
import AssessmentItem from './AssessmentItem';
import { Box, Typography } from '@mui/material';
import AddAssessmentButton from 'domain/people/employee/assessment/List/button/AddAssessmentButton';
import { Alert, Button } from 'framework/ui/mui-builder';
import React, { useState } from 'react';

const AssessmentSectionContent = () => {
  const { data: { items = [] } = {}, loading } = useListContext();
  const [expanded, setExpanded] = useState(false);
  const maxInitialItems = 3;
  const showExpandButton = items.length > maxInitialItems;
  const displayedItems = expanded ? items : items.slice(0, maxInitialItems);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <ListLoadingDecorator items={items} loading={loading} isSmallLoader>
      <Box>
        {items.length ? (
          <>
            <Box
              sx={{
                maxHeight: expanded ? '150px' : 'none',
                overflowY: expanded ? 'auto' : 'visible',
              }}
            >
              {displayedItems.map((assessmentData: any) => {
                const dataInstance = new ShowData(assessmentData);

                return (
                  <ShowContextProvider
                    key={assessmentData.id}
                    value={{
                      data: dataInstance,
                    }}
                  >
                    <AssessmentItem />
                  </ShowContextProvider>
                );
              })}
            </Box>

            {showExpandButton && (
              <Box mt={1} textAlign="center">
                <Button variant="text" size="small" onClick={toggleExpand} sx={{ color: 'primary.main' }}>
                  <Typography variant="body1">{expanded ? 'Show less' : `Show all (${items.length})`}</Typography>
                </Button>
              </Box>
            )}
          </>
        ) : (
          <Alert color="info">Assessments not found</Alert>
        )}
      </Box>

      <Box display="flex" justifyContent="flex-end">
        <AddAssessmentButton />
      </Box>
    </ListLoadingDecorator>
  );
};

export default AssessmentSectionContent;
